import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { MonthYearField, ClassificatorField } from '../../atoms';
import {
  FormActions,
  AutoCompleteCompaniesField,
  TableActions,
} from '../../components';
import { connect } from 'react-redux';
import { downloadFileByPostURL } from '../../utils/files';
import { links } from '../../utils/gotoLink';
import { FORM_INVOICE_FILTER } from '../../constants/formKeys';
import { fromInvoiceFilterFields } from '../../constants/forms/formInvoiceFilter';
import { Collapse, Row, Col, Button } from 'antd';
import { getRole } from '../../reducers/userReducer';
import { isAdmin } from '../../utils/roles';
import * as actions from '../../actions/actionCreators/invoiceSearchActionCreators';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import RffFields from '../../atoms/rff/RffFields';

const { Panel } = Collapse;

export class InvoiceFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    filterValues: PropTypes.object,
    userRole: PropTypes.string.isRequired,
    searchInvoices: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount = () => this.props.searchInvoices();

  onClear = (form) => {
    form.restart({});
    this.props.updateFormState(FORM_INVOICE_FILTER, { values: {} });
    this.props.searchInvoices();
  };

  onSubmit = () => {
    this.props.searchInvoices();
  };

  handleExportInvoices = () => {
    const { filterValues } = this.props;

    downloadFileByPostURL(
      links.invoiceExportCsv,
      filterValues || {},
      'invoices.csv'
    );
  };

  render() {
    const { t, userRole } = this.props;

    const isUserAdmin = isAdmin(userRole);

    return (
      <React.Fragment>
        <Collapse defaultActiveKey={['filters']}>
          <Panel key="filters" header={t('filter.panelTitle')}>
            <Form
              onSubmit={this.onSubmit}
              render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux form={FORM_INVOICE_FILTER} />
                  <Row gutter={32}>
                    <Col span={8}>
                      <Field
                        label={t('filter.status')}
                        name={fromInvoiceFilterFields.STATUS}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.invoiceStatus
                        }
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={8}>
                      <RffFields
                        label={t('filter.period')}
                        names={[
                          fromInvoiceFilterFields.MONTH,
                          fromInvoiceFilterFields.YEAR,
                        ]}
                        className="date-field"
                        component={MonthYearField}
                        hasFeedback={false}
                      />
                    </Col>
                    {isUserAdmin && (
                      <Col span={8}>
                        <Field
                          label={t('filter.presenter')}
                          name={fromInvoiceFilterFields.PRESENTER}
                          component={AutoCompleteCompaniesField}
                          hasFeedback={false}
                        />
                      </Col>
                    )}
                  </Row>

                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('filter.clearBtn')}
                    </Button>
                    <Button type="primary" htmlType="submit">
                      {t('filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              )}
            />
          </Panel>
        </Collapse>
        <TableActions>
          <Button onClick={this.handleExportInvoices}>
            {t('filter.exportCsvBtn')}
          </Button>
        </TableActions>
      </React.Fragment>
    );
  }
}

const selector = formValueSelector(FORM_INVOICE_FILTER);

const mapStateToProps = (state) => ({
  filterValues: selector(state),
  userRole: getRole(state),
});

const mapDispatchToProps = {
  searchInvoices: actions.searchInvoices,
  updateFormState,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceFilter);
